<!-- components/car-card/car-card.html -->
<div class="car-card">
  <!-- Título -->
  <h2 class="car-title">{{ title }}</h2>

  <div class="car-content">
    <!-- Coluna esquerda - Informações -->
    <div class="info-column">
      <app-info-field
        [data]="infoFieldData"
        [columns]="1">
      </app-info-field>
    </div>

    <!-- Coluna direita - Imagem e valores -->
    <div class="image-values-column">
      <!-- Imagem do carro -->
      <div *ngIf="hasCarImage" class="car-image-container">
        <img
          [src]="carImage"
          alt="Imagem do carro"
          class="car-image">
      </div>

      <!-- Container dos valores com divider posicionado absolutamente -->
      <div class="values-container">
        <!-- Divider vertical posicionado absolutamente na esquerda -->
        <div class="vertical-divider"></div>

        <div class="value-item">
          <span class="value-label">Entrada</span>
          <span class="value-amount">{{ entrada }}</span>
        </div>
        <div style="height: 0.5rem;"></div>

        <div class="value-line">
          <span class="value-label">Saldo em </span>
          <span class="parcelas-value">{{ parcelas }}</span>
        </div>

        <div class="value-line">
          <span class="value-label">Parcelas a partir de </span>
          <span class="value-amount">{{ saldoParcelas }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Botão Entrar em Contato -->
  <div class="button-container">
  <button
    class="contact-button"
    (click)="onContactClick()"
    appTrackClick
    trackEvent="nova_simulacao"
    trackCategory="lead_details"
    trackLabel="generate_simulation_from_card">
    Gerar Nova Simulação
  </button>
</div>
</div>
